import React, { PropsWithChildren } from 'react'
import { createContext } from 'lib/createContext'
import { parseErrorMessage } from 'api'
import {
  useCushionChargePoliciesQuery,
  useDeleteCushionChargePolicyMutation,
} from 'queries/company'
import { useCompanyDetailContextValue } from 'pages/Company/CompanyDetail/context/CompanyDetailProvider'
import { CushionChargePolicyItem } from './CushionChargePoliciesWorkflowsProvider'

type CushionChargePoliciesContextState = {
  state: {
    policies: CushionChargePolicyItem[]
    isPending: boolean
    isError: boolean
    errorMessage: string
    isDeleting: boolean
  }
  actions: {
    refetch: ReturnType<typeof useCushionChargePoliciesQuery>['refetch']
    deletePolicy: ReturnType<
      typeof useDeleteCushionChargePolicyMutation
    >['mutate']
  }
}

const [Context, useCushionChargePoliciesContextValue] =
  createContext<CushionChargePoliciesContextState>({
    name: 'CushionChargePoliciesContext',
  })

export const CushionChargePoliciesProvider = ({
  children,
}: PropsWithChildren) => {
  const {
    state: { id: companyId },
  } = useCompanyDetailContextValue()
  const { data, isPending, isError, error, refetch } =
    useCushionChargePoliciesQuery(companyId)
  const { mutate: deletePolicy, isPending: isDeleting } =
    useDeleteCushionChargePolicyMutation(companyId)

  const value: CushionChargePoliciesContextState = {
    state: {
      policies: data?.items ?? [],
      isPending,
      isError,
      errorMessage: parseErrorMessage(error),
      isDeleting,
    },
    actions: {
      refetch,
      deletePolicy,
    },
  }

  return <Context.Provider value={value}>{children}</Context.Provider>
}

export { useCushionChargePoliciesContextValue }
